<div *ngIf="kind !== 'none'" class="ar-card" [ngClass]="'ar-' + kind">
  <!-- one-line results: done / error -->
  <div *ngIf="kind === 'done' || kind === 'error'" class="ar-line">
    <mat-icon class="ar-line-icon">{{ icon }}</mat-icon>
    <span class="ar-line-text">{{ doneText }}</span>
    <button *ngIf="canUndo" class="ar-undo" (click)="undo.emit(action)">Undo</button>
    <span *ngIf="action?.undoState === 'running'" class="ar-muted">Undoing…</span>
    <span *ngIf="action?.undoNote" class="ar-muted">{{ action.undoNote }}</span>
  </div>

  <ng-container *ngIf="kind !== 'done' && kind !== 'error'">
    <div class="ar-head">
      <mat-icon>{{ icon }}</mat-icon>
      <span class="ar-title">{{ title }}</span>
      <input *ngIf="rows.length > 8 && kind !== 'hours' && kind !== 'holidays'" class="ar-filter" placeholder="Filter…" [(ngModel)]="filter" />
    </div>

    <!-- people -->
    <div *ngIf="kind === 'people'" class="ar-rows">
      <div *ngFor="let p of visibleRows" class="ar-row" [class.ar-dim]="p.is_active === false">
        <div class="ar-avatar">{{ initials(p.full_name || p.email) }}</div>
        <div class="ar-main">
          <div class="ar-name">{{ p.full_name || p.email || ('#' + p.id) }}</div>
          <div class="ar-sub" *ngIf="p.email">{{ p.email }}</div>
        </div>
        <span class="ar-chip" [class.ar-chip-strong]="(p.role || '').toUpperCase().includes('MASTER')">{{ roleLabel(p.role) }}</span>
        <span class="ar-chip" [ngClass]="p.has_pin ? 'ar-ok' : 'ar-off'">{{ p.has_pin ? 'PIN' : 'No PIN' }}</span>
      </div>
    </div>

    <!-- one employee -->
    <div *ngIf="kind === 'person'" class="ar-person">
      <div class="ar-row ar-person-head" [class.ar-dim]="result.is_active === false">
        <div class="ar-avatar">{{ initials(result.full_name || result.email) }}</div>
        <div class="ar-main">
          <div class="ar-name">{{ result.full_name || ('#' + result.id) }}</div>
          <div class="ar-sub">{{ result.is_active === false ? 'Deactivated' : 'Active' }}</div>
        </div>
        <span *ngIf="roleName(result)" class="ar-chip" [class.ar-chip-strong]="roleName(result).toUpperCase().includes('MASTER')">{{ roleName(result) }}</span>
      </div>
      <div class="ar-fields">
        <div *ngFor="let f of fields" class="ar-field">
          <span class="ar-field-label">{{ f.label }}</span><span class="ar-field-value">{{ f.value }}</span>
        </div>
      </div>
    </div>

    <!-- one printer -->
    <div *ngIf="kind === 'printer'" class="ar-person">
      <div class="ar-row ar-person-head">
        <span class="ar-dot" [ngClass]="printerOnline(result) === null ? '' : (printerOnline(result) ? 'ar-dot-on' : 'ar-dot-off')"></span>
        <div class="ar-main"><div class="ar-name">{{ result.name }}</div></div>
        <span class="ar-chip" [ngClass]="result.is_enabled ? 'ar-ok' : 'ar-off'">{{ result.is_enabled ? 'On' : 'Off' }}</span>
      </div>
      <div class="ar-fields">
        <div *ngFor="let f of fields" class="ar-field">
          <span class="ar-field-label">{{ f.label }}</span><span class="ar-field-value">{{ f.value }}</span>
        </div>
      </div>
    </div>

    <!-- permissions, by group -->
    <div *ngIf="kind === 'perms'" class="ar-perms">
      <div *ngFor="let g of groups" class="ar-perm-group">
        <div class="ar-perm-name">{{ g.name }} <span class="ar-muted">· {{ g.items.length }}</span></div>
        <div class="ar-perm-chips"><span *ngFor="let p of g.items" class="ar-chip">{{ p }}</span></div>
      </div>
      <div *ngIf="!groups.length" class="ar-muted ar-pad">No permissions.</div>
    </div>

    <!-- menu -->
    <div *ngIf="kind === 'menu'" class="ar-rows">
      <div *ngFor="let m of visibleRows" class="ar-row">
        <div class="ar-main">
          <div class="ar-name">{{ m.name }}</div>
          <div class="ar-sub" *ngIf="m.group || m.modifier_group || m.menu_group">{{ m.group || m.modifier_group || m.menu_group }}</div>
        </div>
        <span class="ar-price" *ngIf="m.base_price !== undefined || m.starting_price !== undefined || m.upcharge !== undefined">
          {{ money(m.base_price ?? m.starting_price ?? m.upcharge) }}
        </span>
        <span *ngIf="m.is_available !== undefined" class="ar-chip" [ngClass]="m.is_available ? 'ar-ok' : 'ar-bad'">
          {{ m.is_available ? 'Available' : "86'd" }}
        </span>
      </div>
    </div>

    <!-- printers -->
    <div *ngIf="kind === 'printers'" class="ar-rows">
      <div *ngFor="let p of visibleRows" class="ar-row">
        <span class="ar-dot" [ngClass]="printerOnline(p) === null ? '' : (printerOnline(p) ? 'ar-dot-on' : 'ar-dot-off')"></span>
        <div class="ar-main">
          <div class="ar-name">{{ p.name }}</div>
          <div class="ar-sub">{{ p.sub || p.station?.name || (p.is_kitchen_printer ? 'Kitchen' : p.is_sales_printer ? 'Receipts' : '') }}</div>
        </div>
        <span class="ar-chip" [ngClass]="p.is_enabled ? 'ar-ok' : 'ar-off'">{{ p.is_enabled ? 'On' : 'Off' }}</span>
      </div>
    </div>

    <!-- sales -->
    <div *ngIf="kind === 'sales'" class="ar-tiles">
      <div *ngFor="let t of tiles" class="ar-tile">
        <div class="ar-tile-value">{{ t.value }}</div>
        <div class="ar-tile-label">{{ t.label }}</div>
      </div>
    </div>

    <!-- store status -->
    <div *ngIf="kind === 'status'" class="ar-status" [ngClass]="result.online_ordering === 'paused' ? 'ar-status-paused' : 'ar-status-open'">
      <div class="ar-status-main">{{ result.online_ordering === 'paused' ? 'Paused' : 'Open' }}
        <span *ngIf="result.paused_until"> until {{ result.paused_until }}</span></div>
      <div class="ar-sub">{{ result.today }} · {{ result.today_hours }} · store time {{ result.store_time }}</div>
    </div>

    <!-- hours -->
    <table *ngIf="kind === 'hours'" class="ar-table">
      <tr *ngFor="let h of rows"><td class="ar-strong">{{ h.day }}</td><td [class.ar-muted]="h.hours === 'closed'">{{ h.hours }}</td></tr>
    </table>

    <!-- holidays -->
    <table *ngIf="kind === 'holidays'" class="ar-table">
      <tr *ngFor="let h of visibleRows"><td class="ar-strong">{{ h.name }}</td><td class="ar-muted">{{ h.date }}</td>
        <td><span class="ar-chip" [ngClass]="h.status === 'closed' ? 'ar-bad' : h.status === 'open' ? 'ar-ok' : 'ar-off'">{{ h.status }}</span></td></tr>
    </table>

    <!-- delivery apps -->
    <div *ngIf="kind === 'delivery'" class="ar-rows">
      <div *ngFor="let a of visibleRows" class="ar-row">
        <span class="ar-dot" [ngClass]="a.online ? 'ar-dot-on' : 'ar-dot-off'"></span>
        <div class="ar-main"><div class="ar-name">{{ label(a.provider) }}</div><div class="ar-sub">{{ a.connection }}</div></div>
        <span class="ar-chip" [ngClass]="a.online ? 'ar-ok' : 'ar-bad'">{{ a.online ? 'Online' : 'Paused' }}</span>
      </div>
      <div *ngIf="!rows.length" class="ar-muted ar-pad">No delivery apps connected.</div>
    </div>

    <!-- storefront / generic fields -->
    <div *ngIf="kind === 'storefront' || kind === 'fields'" class="ar-fields">
      <div *ngFor="let f of fields" class="ar-field">
        <span class="ar-field-label">{{ f.label }}</span>
        <span class="ar-field-value">
          <span *ngIf="f.swatch" class="ar-swatch" [style.background]="f.value"></span>{{ f.value === true ? 'Yes' : f.value === false ? 'No' : (f.value ?? '—') }}
        </span>
      </div>
    </div>

    <!-- generic list -->
    <table *ngIf="kind === 'list'" class="ar-table">
      <tr><th>Name</th><th *ngFor="let c of columns">{{ label(c) }}</th></tr>
      <tr *ngFor="let row of visibleRows">
        <td class="ar-strong">{{ row[nameKey] || ('#' + row.id) }}</td>
        <td *ngFor="let c of columns">{{ cell(row, c) }}</td>
      </tr>
    </table>

    <div *ngIf="!rows.length && (kind === 'people' || kind === 'menu' || kind === 'printers' || kind === 'list')" class="ar-muted ar-pad">
      Nothing found.
    </div>
    <button *ngIf="hiddenCount > 0 && !showAll" class="ar-more" (click)="showAll = true">Show all {{ rows.length }}</button>
    <button *ngIf="showAll && rows.length > 8" class="ar-more" (click)="showAll = false">Show less</button>
  </ng-container>
</div>
